import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-98">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-99" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-101">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-8" data-id="element-102">
            💪 SÌ! VOGLIO ECONOMIA PRO™ ORA
          </h2>

          <CTAButton href={CART_URL} className="text-xl sm:text-2xl py-6 px-10 w-full sm:w-auto max-w-xl mx-auto mb-6" data-id="element-103">
            👉 SÌ! VOGLIO IL SISTEMA COMPLETO ORA
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-brand-gold font-bold text-sm sm:text-base" data-id="element-104">
            <span data-id="element-105">⚡ Accesso immediato</span>
            <span data-id="element-106">·</span>
            <span data-id="element-107">💳 Solo €19,90 — pagamento unico</span>
            <span data-id="element-108">·</span>
            <span data-id="element-109">🛡️ Garanzia 14 giorni soddisfatti</span>
          </div>
        </motion.div>
      </div>
    </section>;
}